import React from "react"
import { Box, Link, Text } from "rebass"
import { SizeMe } from "react-sizeme"
import { motion } from "framer-motion"

import FloatingBox from "./floating-box"
import Cloud from "./cloud"

const RedCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ top: ["30%"], right: 0 }}
  >
    <motion.div
      animate={{ x: "-100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#C03B3B" />
    </motion.div>
  </Box>
)

const YellowCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ top: ["70%"], left: 0 }}
  >
    <motion.div
      animate={{ x: "100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#FDFF00" />
    </motion.div>
  </Box>
)

const ArticleList = ({ articles }) => (
  <SizeMe monitorHeight>
    {size => (
      <Box>
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{
            y: 100,
            x: 40,
          }}
        />
        <FloatingBox
          width={size.size.width}
          height={size.size.height}
          initialPos={{
            y: 150,
            x: 400,
          }}
        />
        <RedCloud />
        <YellowCloud />
        {articles.map((article, index) => (
          <Link
            variant="hyperlink"
            href={article.url}
            target="_blank"
            p={[3, 4]}
            sx={{
              borderColor: "text",
              display: "block",
              textAlign: "center",
            }}
            css={{
              "&:first-of-type": {
                borderTop: "2px solid",
              },
              "&:not(:last-of-type)": {
                borderBottom: "2px solid",
              },
            }}
            key={index}
          >
            <Text as="span" variant="article">
              “{article.heading}”
            </Text>
          </Link>
        ))}
      </Box>
    )}
  </SizeMe>
)

export default ArticleList
